var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#FB8C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7121 14.6418H24.4266V12.2256C24.4266 12.0206 24.2655 11.8544 24.0668 11.8544H23.2544V7.49488C23.2544 7.22156 23.0395 7 22.7746 7H8.4798C8.21481 7 8 7.22156 8 7.49488V16.9562C8 17.2295 8.21481 17.4511 8.4798 17.4511H13.4441C13.3486 18.0169 13.1433 18.9518 12.7301 19.8799C12.6619 20.0331 12.674 20.2116 12.7623 20.3536C12.8505 20.4955 13.0027 20.5814 13.1662 20.5814H16.5501V21.8815C16.5501 22.0865 16.7112 22.2527 16.9099 22.2527H22.0906V22.7031C22.0906 22.867 22.2195 23 22.3784 23H26.7121C26.8711 23 27 22.867 27 22.7031V14.9387C27 14.7747 26.8711 14.6418 26.7121 14.6418ZM16.5501 12.2256V16.4613H8.9596V7.98977H22.2948V11.8544H16.9099C16.7112 11.8544 16.5501 12.0206 16.5501 12.2256ZM22.0906 21.5104H17.2698V21.0794H20.1286V21.1142C20.1286 21.3192 20.2896 21.4854 20.4884 21.4854C20.6872 21.4854 20.8483 21.3192 20.8483 21.1142V21.0794H22.0906V21.5104ZM22.0906 14.9387V20.337H17.2698V12.5967H23.7069V14.6418H22.3784C22.2194 14.6418 22.0906 14.7747 22.0906 14.9387ZM26.4242 22.4061H22.6663V22.0565H24.2574V22.086C24.2574 22.2501 24.3863 22.383 24.5453 22.383C24.7043 22.383 24.8332 22.2501 24.8332 22.086V22.0565H26.4242V22.4061ZM26.4242 21.4626H22.6663V16.1792H26.4242V21.4626ZM26.4242 15.5853H22.6663V15.2357H26.4242V15.5853Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceType);
export default __webpack_public_path__ + "static/media/deviceType.fb7b1a4ea401c51ba09a524d6fca36dc.svg";
export { ForwardRef as ReactComponent };